module.exports = __webpack_public_path__ + "static/media/CrifTimelineTrees.a6d00ab6.svg";